<template>
  <v-card flat>
    <v-card-text class="pb-0">
      <v-row>
        <v-col
          cols="12"
          md="3"
        >
          <v-row class="flex-column">
            <center>
              <v-avatar
                v-if="image"
                size="120"
                tile
                @click="$refs.courseImageInput.click()"
              >
                <img
                  :src="image"
                  alt="courseImage"
                >
              </v-avatar>
              <v-avatar
                v-else
                ref="courseImage"
                size="120"
                color="orange"
                tile
                class="mb-3"
                @click="$refs.courseImageInput.click()"
              >
                <v-icon size="48">
                  fas fa-gift
                </v-icon>
              </v-avatar>
              <input
                ref="courseImageInput"
                type="file"
                style="display: none;"
                accept="image/png, image/jpeg, image/jpg"
                @input="readFile"
              >
              <span
                v-if="$v.file.$dirty && !$v.file.imageValidator"
                class="red--text text-ex-center"
              >
                {{ imageErrors[0] }}
              </span>
            </center>
            <center>
              <h3>มูลค่ารวม: {{ value }} บาท</h3>
            </center>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="9"
        >
          <v-row no-gutters>
            <v-col
              cols="12"
            >
              <v-text-field
                v-model.trim="name"
                :error-messages="nameErrors"
                label="ชื่อบริการคอร์ส"
                filled
                color="orange"
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.trim="price"
                :error-messages="priceErrors"
                label="ราคา"
                filled
                class="pr-1"
                color="orange"
                @input="$v.price.$touch()"
                @blur="$v.price.$touch()"
              />
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model.trim="time"
                label="ระยะเวลา [ นาที ]"
                filled
                class="pl-1"
                color="orange"
                readonly
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col
          cols="12"
        >
          <v-autocomplete
            v-model="selectedService"
            :error-messages="selectedServiceError"
            :items="services"
            item-value="_id"
            item-text="name"
            label="บริการ"
            filled
            multiple
            color="orange"
            item-color="orange"
            @blur="$v.selectedService.$touch()"
            @input="$v.selectedService.$touch()"
          >
            <template v-slot:selection="data">
              <v-chip
                close
                close-icon="fas fa-times-circle"
                :input-value="data.selected"
                @click="data.select"
                @click:close="removeService(data.item._id)"
              >
                <v-avatar left>
                  <v-img
                    v-if="data.item.image"
                    :src="data.item.image"
                  />
                  <v-icon v-else>
                    fas fa-spa
                  </v-icon>
                </v-avatar>
                {{ data.item.name }} [ {{ data.item.price }} บาท ]
              </v-chip>
            </template>
            <template v-slot:item="data">
              <v-list-item-avatar>
                <v-img
                  v-if="data.item.image"
                  :src="data.item.image"
                />
                <v-icon v-else>
                  fas fa-spa
                </v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>
                  {{ data.item.name }}
                </v-list-item-title>
                <v-list-item-subtitle>
                  {{ data.item.price }} บาท
                  [ {{ data.item.time }} นาที ]
                </v-list-item-subtitle>
              </v-list-item-content>
            </template>
          </v-autocomplete>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="orange"
        block
        @click="submit"
      >
        บันทึก
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {
  required,
  maxLength,
  minLength,
  numeric,
} from 'vuelidate/lib/validators';
import imageValidator from '@/utils/imageValidator';


export default {
  name: 'CourseForm',
  validations: {
    name: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(255),
    },
    price: {
      required,
      numeric,
    },
    selectedService: {
      required,
      minLength: minLength(2),
    },
    file: {
      imageValidator,
    },
  },
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    services: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      name: '',
      image: '',
      file: '',
      selectedService: [],
      value: 0,
      price: '',
      time: 0,
    };
  },
  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      if (!this.$v.name.required) {
        errors.push('กรุณากรอกชื่อบริการคอร์ส');
      }
      if (!this.$v.name.minLength) {
        errors.push('ความยาวของชื่อต้องไม่น้อยกว่า 2 ตัวอักษร');
      }
      if (!this.$v.name.maxLength) {
        errors.push('ความยาวของชื่อต้องไม่เกิน 255 ตัวอักษร');
      }
      return errors;
    },
    priceErrors() {
      const errors = [];
      if (!this.$v.price.$dirty) return errors;
      if (!this.$v.price.required) {
        errors.push('กรุณากรอกราคาบริการคอร์ส');
      }
      if (!this.$v.price.numeric) {
        errors.push('ราคาต้องเป็นตัวเลขเท่านั้น');
      }
      return errors;
    },
    imageErrors() {
      const errors = [];
      if (!this.$v.file.$dirty) return errors;
      if (!this.$v.file.imageValidator) {
        errors.push('ขนาดไฟล์ต้องไม่เกิน 5 mb');
      }
      return errors;
    },
    selectedServiceError() {
      const errors = [];
      if (!this.$v.selectedService.$dirty) return errors;
      if (!this.$v.selectedService.required) {
        errors.push('กรุณาเลือกบริการ');
      }
      if (!this.$v.selectedService.minLength) {
        errors.push('บริการคอร์สต้องมีบริการอย่างน้อย 2 บริการ');
      }
      return errors;
    },
  },
  watch: {
    services(value) {
      this.service = [...value];
    },
    selectedService(value) {
      if (value) {
        this.calculate();
      }
    },
    formData(value) {
      this.name = value.name;
      this.image = value.image;
      // eslint-disable-next-line
      this.selectedService = value.services.map(service => service._id);
      this.value = value.value;
      this.price = value.price;
      this.time = value.time;
    },
  },
  methods: {
    readFile(event) {
      const input = event.target;
      if (input.files[0]) {
        this.$v.file.$touch();
        const reader = new FileReader();
        reader.onload = (ev) => {
          this.image = ev.target.result;
        };
        // eslint-disable-next-line
        this.file = input.files[0];
        reader.readAsDataURL(input.files[0]);
      }
    },
    calculate() {
      let time = 0;
      let value = 0;
      this.selectedService.forEach((id) => {
        // eslint-disable-next-line
        const service = this.services.find(element => element._id === id);
        time += service.time;
        value += service.price;
      });
      this.value = value;
      this.time = time;
    },
    removeService(id) {
      this.selectedService = this.selectedService.filter(service => service !== id);
    },
    submit() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const data = {
          name: this.name,
          price: this.price,
          value: this.value,
          services: this.selectedService,
          time: this.time,
        };
        if (this.file) {
          data.image = this.file;
        }
        this.$emit('submit', data);
      }
    },
  },
};
</script>
